export default () => ({
  navigate(e = { detail: '/' }) {
    // check url for id and simulate a click on marker
    window.history.pushState(null, null, e.detail);
    this.parseUrl();
    this.dispatchNavigation();
  },
  initialNavigate() {
    this.parseUrl();
    this.dispatchNavigation();
  },
  dispatchNavigation() {
    if (this.$store.router.section === 'candidates') {
      this.$dispatch('route-change-candidates');
    } else if (this.$store.router.section === 'map') {
      this.$dispatch('route-change');

      if (this.$store.router.id) {
        this.$dispatch('show-map');
      }
    }
  },
  parseUrl() {
    const currentUrl = new URL(window.location);

    if (currentUrl.pathname && currentUrl.pathname.includes('/clenove')) {
      this.$store.router.section = 'candidates';
      this.$store.router.id = currentUrl.pathname.replace('/clenove', '');
    } else if (currentUrl.pathname && currentUrl.pathname !== '/') {
      this.$store.router.section = 'map';
      this.$store.router.id = currentUrl.pathname.substr(1);

      // const currentMarker = markersData.find((marker) => marker.id === id);
    } else {
      this.$store.router.section = 'map';
      this.$store.router.id = null;
    }
  },
  init() {
    window.onpopstate = () => {
      this.parseUrl();
      this.dispatchNavigation();
    };
  },
});
